import { ClientJS } from 'clientjs';
import { Stomp } from '@stomp/stompjs';
import React, { useEffect, useRef, useState } from 'react';
import { IoNotificationsCircleOutline, IoNotificationsOutline, IoClose } from 'react-icons/io5';
import { LuMail, LuMailOpen } from 'react-icons/lu';
import addNotification from 'react-push-notification';
import { toast } from 'react-toastify';
import SockJS from 'sockjs-client';
import logo from '../assets/logo.png';
import notifysound from '../assets/notification.mp3';
import profile from '../assets/profile.png';
import profile1 from '../assets/profile1.png';
import {
  WEBSOCKET_URL,
  getNotifications,
  logoutUser,
  markAsReadNotify,
  stringAvatar,
  timeAgo,
} from '../service/service-call';
import ForceLogout from '../Pages/ForceLogout';

export default function HeaderNav() {
  const [notifications, setNotifications] = useState([]);
  const [notificationUnreadCount, setNotificationUnreadCount] = useState(0);
  const [notifyPanelOpen, setNotifyPanelOpen] = useState(false);
  const [accountMenuOpen, setAccountMenuOpen] = useState(false);
  const [isForceLogoutModalOpen, setIsForceLogoutModalOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [isErrorListModalOpen, setIsErrorListModalOpen] = useState(false);
  const [errorIntro, setErrorIntro] = useState('');
  const [errorTaskIds, setErrorTaskIds] = useState([]);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  
  const audioRef = useRef(null);
  const notifyRef = useRef(null);
  const accountRef = useRef(null);

  const playNotificationSound = () => {
    if (audioRef.current) {
      audioRef.current.play().catch((error) => {
        console.error('Failed to play the sound:', error);
      });
    }
  };
  const toggleErrorListModal = () => {
    setIsErrorListModalOpen(!isErrorListModalOpen);
  };

  function parseTaskListMessage(message) {
    const match = message.match(/^(.*?):\s*\[(.*)\]\s*$/s);
    if (match) {
      const intro = match[1].trim();
      const ids = match[2]
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);
      return { intro, ids };
    }
    // fallback: couldn't parse, just show as-is
    return { intro: message, ids: [] };
  }

  useEffect(() => {
    connect();
    getAllNotifications();
  }, []);

  // close dropdowns on outside click
  useEffect(() => {
    function handleClickOutside(e) {
      if (notifyRef.current && !notifyRef.current.contains(e.target)) {
        setNotifyPanelOpen(false);
      }
      if (accountRef.current && !accountRef.current.contains(e.target)) {
        setAccountMenuOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  function getAllNotifications() {
    getNotifications()
      .then((resp) => {
        if (resp.status === 401) {
          logout();
        }
        resp.json().then((data) => {
          setNotifications(data);
          const unread = data.filter((e) => e.viewStatus === false);
          setNotificationUnreadCount(unread.length);
        });
      })
      .catch((error) => {
        console.log('login user err ' + error);
      });
  }

  const connect = () => {
    const sock = new SockJS(WEBSOCKET_URL);
    const stompClient = Stomp.over(sock);

    sock.onopen = function () {
      console.log('open');
    };
    stompClient.connect({}, function (frame) {
      console.log('Connected: ' + frame);
      stompClient.subscribe(
        '/user/' + localStorage.getItem('userId') + '/reply',
        function (greeting) {
          const payload = JSON.parse(greeting.body);
          playNotificationSound();
          notifyUser(payload.from.firstName + ' ' + payload.from.lastName, payload.message);
          getAllNotifications();
        }
      );
    });
  };

  function notifyUser(sender, message) {
    addNotification({
      title: 'CrewKeeper',
      subtitle: '',
      message: sender + ': ' + message,
      theme: 'darkblue',
      native: true,
    });
  }

  const account = {
    photoURL:
      localStorage.getItem('gender') && localStorage.getItem('gender') === 'female'
        ? profile1
        : profile,
    displayName: localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname'),
    role: 'software devloper',
  };

  const toggleForceLogoutModal = () => {
    setIsForceLogoutModalOpen(!isForceLogoutModalOpen);
  };

  const logout = () => {
    setIsLoggingOut(true);
    navigator.geolocation.getCurrentPosition((position) => {
      const { latitude, longitude } = position.coords;
      const client = new ClientJS();
      logoutUser(
        client.getOS(),
        client.getBrowserData().browser.name,
        client.getFingerprint(),
        latitude,
        longitude
      )
        .then((resp) => {
          if (resp.status === 401) {
            toast.error('Unauthozied entry!');
          }
          localStorage.removeItem('firstname');
          localStorage.removeItem('lastname');
          localStorage.removeItem('email');
          localStorage.removeItem('userId');
          localStorage.removeItem('token');
          localStorage.removeItem('role');
          localStorage.removeItem('isTL');
          window.location.replace('/');
        })
        .catch((error) => {
          setIsLoggingOut(false);
          console.log('login user err ', error.response);
          if (error.response.status === 400) {
            setErrorMsg(error.response.data.message);
            toggleForceLogoutModal();
          }
          if (error.response.status === 417) {
            const { intro, ids } = parseTaskListMessage(error.response.data.message);
            setErrorIntro(intro);
            setErrorTaskIds(ids);
            setIsErrorListModalOpen(true);
          }
        });
    });
  };

  function markAsRead(id, status) {
    markAsReadNotify(id, !status)
      .then((resp) => {
        setNotifications(resp.data);
        const unread = resp.data.filter((e) => e.viewStatus === false);
        setNotificationUnreadCount(unread.length);
      })
      .catch((error) => {
        if (error?.response?.data?.message) {
          toast.error(error.response.data.message);
        } else if (error?.response?.data?.errors?.length > 0) {
          toast.error(error.response.data.errors[0]);
        } else {
          toast.error('Internal server error, contact support team');
        }
      });
  }

  return (
    <>
      <header style={{ background: "inherit" }} className="sticky
    top-0
    z-50
    w-90
    border-gray-200
    shadow-sm">
        <div className="flex h-16 items-center justify-between px-2 lg:px-10">
          {/* Logo */}
          {/* <img src={logo} alt="Logo" className="h-12 w-auto object-contain" /> */}
          <div  className="h-12 w-auto object-contain"></div>

          <audio ref={audioRef} src={notifysound} preload="auto" />

          <div className="flex items-center gap-3">
            {/* Notification bell */}
<div className="relative" ref={notifyRef}>
  <button
    onClick={() => setNotifyPanelOpen((p) => !p)}
    className="relative flex h-10 w-10 items-center justify-center rounded-full text-[#262673] transition-colors hover:bg-orange-50"
  >
    <IoNotificationsCircleOutline size={28} />
    {notificationUnreadCount > 0 && (
      <span className="absolute -top-0.5 -right-0.5 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-orange-500 px-1 text-[10px] font-semibold text-white shadow ring-2 ring-white">
        {notificationUnreadCount}
      </span>
    )}
  </button>

  {/* Notification dropdown */}
  {notifyPanelOpen && (
    <div className="absolute right-0 mt-3 w-[360px] origin-top-right overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-2xl ring-1 ring-black/5 animate-in fade-in slide-in-from-top-2 duration-200">
      {/* Header */}
      <div className="flex items-center justify-between bg-gradient-to-r from-[#1b1b3a] via-[#242463] to-[#262673] px-5 py-4">
        <div className="flex items-center gap-2">
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-white/10">
            <IoNotificationsOutline size={16} className="text-white" />
          </div>
          <div>
            <p className="text-sm font-semibold text-white">Notifications</p>
            {notificationUnreadCount > 0 && (
              <p className="text-[11px] text-white/60">{notificationUnreadCount} unread</p>
            )}
          </div>
        </div>
        <button
          onClick={() => setNotifyPanelOpen(false)}
          className="flex h-7 w-7 items-center justify-center rounded-full text-white/60 transition-colors hover:bg-white/10 hover:text-white"
        >
          <IoClose size={16} />
        </button>
      </div>

      {/* List */}
      <div className="max-h-[350px] overflow-y-auto">
        {notifications.length === 0 ? (
          <div className="flex flex-col items-center justify-center gap-2 px-6 py-12">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-50">
              <IoNotificationsOutline size={22} className="text-gray-300" />
            </div>
            <p className="text-sm font-medium text-gray-400">No messages found</p>
            <p className="text-xs text-gray-300">You're all caught up</p>
          </div>
        ) : (
          notifications.map((e) => (
            <div
              key={e.id}
              onClick={() => markAsRead(e.id, e.viewStatus)}
              className={`group relative flex cursor-pointer items-start gap-3 border-b border-gray-50 px-5 py-3.5 transition-colors last:border-b-0 hover:bg-gray-50/80 ${
                !e.viewStatus ? 'bg-orange-50/40' : ''
              }`}
            >
              {/* unread dot */}
              {!e.viewStatus && (
                <span className="absolute left-1.5 top-1/2 h-1.5 w-1.5 -translate-y-1/2 rounded-full bg-orange-500" />
              )}

              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#262673]/10 to-[#262673]/5 text-xs font-semibold text-[#262673]">
                {stringAvatar
                  ? stringAvatar(e.from.firstName + ' ' + e.from.lastName)?.children
                  : `${e.from.firstName?.[0] ?? ''}${e.from.lastName?.[0] ?? ''}`}
              </div>

              <div className="min-w-0 flex-1 pt-0.5">
                <p className="line-clamp-2 text-sm leading-snug text-gray-700">
                  <span className={`font-semibold ${!e.viewStatus ? 'text-gray-900' : 'text-gray-600'}`}>
                    {e.from.firstName} {e.from.lastName}
                  </span>{' '}
                  {e.message}
                </p>
                <p className="mt-1 text-[11px] font-medium text-gray-400">{timeAgo(e.time)}</p>
              </div>

              <button
                title={e.viewStatus ? 'Mark as unread' : 'Mark as read'}
                className="shrink-0 rounded-full p-1.5 text-gray-300 opacity-0 transition-all group-hover:opacity-100 hover:bg-orange-100 hover:text-orange-500"
              >
                {e.viewStatus ? <LuMailOpen size={15} /> : <LuMail size={15} />}
              </button>
            </div>
          ))
        )}
      </div>

      {/* Footer */}
      {notifications.length > 0 && (
        <div className="border-t border-gray-50 bg-gray-50/50 px-5 py-2.5 text-center">
          <button
            onClick={() => setNotifyPanelOpen(false)}
            className="text-xs font-medium text-[#262673] transition-colors hover:text-orange-500"
          >
            Close
          </button>
        </div>
      )}
    </div>
  )}
</div>

            {/* Account */}
            <div className="relative" ref={accountRef}>
              <button
                onClick={() => setAccountMenuOpen((p) => !p)}
                className="flex items-center gap-2 rounded-full py-1 pl-1 pr-3 transition-colors hover:bg-orange-50"
              >
                <span className="hidden text-sm font-medium text-[#262673] sm:inline">
                  {account.displayName}
                </span>
                {account.photoURL ? (
                  <img
                    src={account.photoURL}
                    alt="avatar"
                    className="h-9 w-9 rounded-full border-2 border-gray-100 object-cover"
                  />
                ) : (
                  <div className="flex h-9 w-9 items-center justify-center rounded-full border-2 border-gray-100 bg-[#262673] text-sm font-semibold text-white">
                    {account.displayName.charAt(0).toUpperCase()}
                  </div>
                )}
              </button>

              {accountMenuOpen && (
  <div className="absolute right-0 mt-2 w-40 overflow-hidden rounded-xl border border-gray-100 bg-white py-1 shadow-xl animate-in fade-in slide-in-from-top-2 duration-150">
    <button
      onClick={logout}
      disabled={isLoggingOut}
      className="flex w-full items-center gap-2 px-4 py-2 text-left text-sm text-gray-700 transition-colors hover:bg-orange-50 hover:text-orange-600 disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:bg-transparent"
    >
      {isLoggingOut && (
        <span className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-gray-300 border-t-[#262673]" />
      )}
      {isLoggingOut ? 'Logging out...' : 'Logout'}
    </button>
  </div>
)}
            </div>
          </div>
        </div>
      </header>

      {/* Force logout modal */}
      {isForceLogoutModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div className="w-full max-w-[600px] rounded-2xl bg-white shadow-2xl">
            <ForceLogout toggleForceLogoutModal={toggleForceLogoutModal} errorMsg={errorMsg} />
          </div>
        </div>
      )}


      {isErrorListModalOpen && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm px-4">
    <div className="w-full max-w-[560px] overflow-hidden rounded-2xl bg-white shadow-2xl">
      {/* Header */}
      <div className="flex items-center justify-between bg-gradient-to-r from-[#1b1b3a] to-[#262673] px-5 py-4">
        <p className="text-sm font-semibold text-white">Unable to log out</p>
        <button
          onClick={toggleErrorListModal}
          className="flex h-7 w-7 items-center justify-center rounded-full text-white/60 transition-colors hover:bg-white/10 hover:text-white"
        >
          <IoClose size={16} />
        </button>
      </div>

      {/* Body */}
      <div className="px-5 py-4">
        <p className="mb-3 text-sm text-gray-700">
          {errorIntro}
          {errorTaskIds.length > 0 && (
            <span className="ml-1 font-semibold text-[#262673]">
              ({errorTaskIds.length} task{errorTaskIds.length > 1 ? 's' : ''})
            </span>
          )}
        </p>

        {errorTaskIds.length > 0 && (
          <div className="max-h-[280px] overflow-y-auto rounded-lg border border-gray-100 bg-gray-50/60 p-3">
            <div className="flex flex-wrap gap-1.5">
              {errorTaskIds.map((id) => (
                <span
                  key={id}
                  className="rounded-md border border-orange-200 bg-orange-50 px-2 py-1 text-xs font-medium text-orange-700"
                >
                  {id}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="border-t border-gray-100 px-5 py-3 text-right">
        <button
          onClick={toggleErrorListModal}
          className="rounded-lg bg-[#262673] px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-orange-500"
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}
    </>
  );
}